import React from 'react';
import { FiActivity, FiCast, FiMap } from "react-icons/fi";
import {Link} from "react-router-dom";
import ScrollAnimation from "react-animate-on-scroll";

const ServiceList = [
    {
        icon: <FiActivity />,
        title: 'Online Courses',
        description: 'Unlock your entrepreneurial potential with our comprehensive online business course, designed to equip you with essential knowledge & skills for success in today’s digital landscape'
    },
    {
        icon: <FiCast />,
        title: 'Expert Instructor',
        description: 'Learn from industry-leading expert who bring invaluable real-world experience to every lesson, ensuring a dynamic and enriching educational journey'
    },
    {
        icon: <FiMap />,
        title: 'Unlimited Access',
        description: 'Gain unlimited access to a wealth of resources and course materials, empowering you to learn at your own pace and maximize your potential.'
    },
]

const ServiceOne = ({textAlign, serviceStyle}) => {
    return (
        <div className="row row--15 service-wrapper">
              {ServiceList.map( (val , i) => (
                <div className="col-lg-4 col-md-6 col-sm-6 col-12" key={i}>
                    <ScrollAnimation 
                    animateIn="fadeInUp"
                    animateOut="fadeInOut"
                    animateOnce={true}>
                        <div className={`service ${serviceStyle} ${textAlign}`}>
                            <div className="icon">
                                {val.icon}
                            </div>
                            <div className="content">
                                <h4 className="title w-600"><Link to="#service" dangerouslySetInnerHTML={{__html: val.title}}></Link></h4>
                                <p className="description b1 color-gray mb--0" dangerouslySetInnerHTML={{__html: val.description}}></p>
                            </div>
                        </div>
                    </ScrollAnimation>
                </div>
            ))}
        </div>
    )
}
export default ServiceOne;